import { render, staticRenderFns } from "./TelaNovaPedido.vue?vue&type=template&id=5dad892e&scoped=true&"
import script from "./TelaNovaPedido.vue?vue&type=script&lang=js&"
export * from "./TelaNovaPedido.vue?vue&type=script&lang=js&"
import style0 from "./TelaNovaPedido.vue?vue&type=style&index=0&id=5dad892e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad892e",
  null
  
)

export default component.exports